import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * SAMPLE COPY — the product has no buyers yet.
 * Replace every quote, name and photo with a real buyer review (with
 * permission) before running traffic. US FTC rules prohibit fabricated reviews.
 * Keep reviews free of body-result claims (no "toned", "lost weight").
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      "I opened Week 1 on Sunday night and taught it Monday morning. It's the first time in months I didn't write a class from scratch.",
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      'The easy and hard versions sold me. My 6am class goes from first-timers to eight-year regulars, and now everyone has a lane.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      'I teach at a YMCA on top of my day job. With the year mapped, prep is ten minutes instead of my whole evening.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The Tempo Dial volume is so simple. Same blocks, different speed, and my regulars think it is a brand-new class.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'No song titles, just BPM. I use my own playlist and the counts still land.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      "The first-timer lane on every Week Card is the detail I didn't know I needed.",
    author: coaches[5].name,
    role: coaches[5].role,
    avatar: coaches[5].avatar,
  },
]
